import MojitoCore from 'mojito/core';
import MojitoModules from 'mojito/modules';

import {mergeTo} from '#core/utils/config-utils.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {EventPage} from '../event-page.js';

import {marketsFactory} from './markets.factory';

import PALETTE_SCHEMA from './markets.palette-schema.yaml';
import SCHEMA from './markets.schema.yaml';

const merge = MojitoCore.Presentation.uiStyle.merge;

const SelectionButtonTypes = MojitoModules.SelectionButton.types;

class MarketsFeature extends AbstractVisualFeature {
    get name() {
        return 'Markets';
    }

    get configSchema() {
        return SCHEMA;
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const responsiveSelections = this.config.enableResponsiveSelections
            ? {
                  genericMarketContent: {
                      market: {
                          direction: 'auto',
                          selectionLayoutOverrides: {
                              column: 'horizontalAlignLeft',
                          },
                      },
                  },
              }
            : {};

        return mergeTo(marketsFactory(PALETTE), {
            GenericMarketContent: {
                rowsThreshold: this.config.rowsThreshold,
                numberOfExpandedRows: this.config.numberOfExpandedRows,
                market: {
                    selectionButton: {
                        view: {
                            infoTextOverrides: {
                                horizontalAlignLeft: {
                                    truncate: true,
                                    ellipsisOnLineNumber: this.config.ellipsisOnLineNumber,
                                },
                                horizontalAlignCenter: {
                                    truncate: true,
                                    ellipsisOnLineNumber: this.config.ellipsisOnLineNumber,
                                },
                            },
                        },
                    },
                },
                layoutDescriptors: {
                    types: (this.config.withHiddenHeaders || []).reduce((acc, marketType) => {
                        acc[marketType] = {selectionsHeaderContent: 'undefined'};

                        return acc;
                    }, {}),
                },
            },
            EventListItem: {
                genericMarketContent: {
                    layoutDescriptors: {
                        ...this.config.couponLayout,

                        //remove this when MOJ-17604 released
                        default: {
                            _mobile_selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.HIDE,
                        },
                        types: {
                            ...((this.config.couponLayout && this.config.couponLayout.types) || {}),
                            // TODO (Mojito team):
                            // These market-type overrides (COH3 and COF3) should be configured
                            // directly in Mojito's layout descriptor registry instead of DBX-level overrides.
                            //
                            // This DBX override is a temporary workaround until Mojito provides
                            // first-class support for Corner 3-Way market types.
                            COH3: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.HIDE},
                            COF3: {selectionNameDisplay: SelectionButtonTypes.NAME_DISPLAY.HIDE},
                        },
                    },
                },
            },

            EventMarkets: merge(
                {
                    genericMarketContent: {
                        layoutDescriptors: {
                            ...this.config.eventPageLayout,
                        },
                    },
                    handicapMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    correctScoreMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    gameLineMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    threeWayMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    threeWayHandicapMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    setScoreMarketContent: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                ...this.config.eventPageLayout,
                            },
                        },
                    },
                    goalScorerMarketContent: {
                        enableResponsiveMarketGroups: this.config.enableResponsiveMarketGroups,
                    },
                },
                responsiveSelections
            ),
            EventMarketsGroupSwitcher: {
                marketThreshold: this.config.marketThreshold,
            },
            AggregatedMarketGroup: {
                goalScorerMarketContent: {
                    enableResponsiveMarketGroups: this.config.enableResponsiveMarketGroups,
                },
            },
        });
    }
}

export const Markets = new MarketsFeature(EventPage);
